import React from 'react';
import './icon.scss';
import { IconProps } from '../../types/icons';

const QuestionMarkIcon: React.FC<IconProps> = ({
  fill,
  color,
  width = 24,
  height,
  onClick,
  className = '',
}) => {
  const classBase = 'custom-icon';
  const classes = `${classBase} ${classBase}-color-${color} ${className}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height || width}
      className={classes}
      fill={fill || '#7E8A96'}
      onClick={onClick}
      data-testid="question-mark-icon"
      viewBox="0 0 24 24"
    >
      <path
        fill={fill || '#7E8A96'}
        fillRule="evenodd"
        d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zM4 12a8 8 0 1016 0 8 8 0 00-16 0z"
        clipRule="evenodd"
      />
      <path
        fill={fill || '#7E8A96'}
        d="M11.19 16.68a.82.82 0 111.64-.001.82.82 0 01-1.64 0zM12.283 6.5c2.955.12 4.235 3.098 2.495 5.32-.46.547-1.193.908-1.565 1.378a1.61 1.61 0 00-.334.747c-.082.446-.417.819-.87.819s-.83-.368-.81-.821c.026-.57.108-1.057.372-1.434.361-.547 1.095-.876 1.554-1.237 1.347-1.237.996-2.977-.842-3.12-.619 0-1.164.349-1.444.866-.215.398-.566.787-1.02.787-.452 0-.83-.373-.72-.812A3.294 3.294 0 0112.284 6.5z"
      />
    </svg>
  );
};

export default QuestionMarkIcon;
